
(function(){
    var EVT_ItemTemplate = '{{#each (item, index) in eventList}}'+
        '<li class="slide-conts ui_carousel_slide">'+
            '<div class="list-inner">\n' +
                '<a href="{{item.eventUrl}}" data-target-id="{{item.eventId}}" data-contents="{{scenarioNumber}}/{{index + 1}}/{{item.eventId}}">' + 
                    '<span class="thumb c-lazy-media">' +
                        '<img class="c-lazy-media__element" data-lazy-src="{{item.eventListThumbnailPath}}" alt="" aria-hidden="true">' +
                    '</span>' +
                    '<div class="info">' +
                        '<p class="tit"><span class="blind">이벤트 제목</span>{{item.eventTitle}}</p>' +
                        '<p class="date"><span class="blind">이벤트 기간</span>{{item.eventFromDate}}~{{item.eventToDate}}</p>\n' +
                    '</div>' +
                '</a>' +
            '</div>' +
        '</li>'+
        '{{/each}}';

    $(function() {

        var isRecommendVisible = false;
        var gaData = {};
        var evtDetail_SlideList = {
            init: function(){
                var self = this;
                // 기획전은 일반, 함께구매만 이벤트는 'online' 일때만 추천 영역 노출
                var isDisplayYn = $('.recomm-exhibitions-inner').attr('data-is-display-yn');
                var targetId = $('.recomm-exhibitions-inner').attr('data-target-id');
                var eventEndFlag = $('.recomm-exhibitions-inner').attr('data-event-end-flag');
                
                if ('Y' == isDisplayYn) {
                    self.setting();
                }

                // 이력 저장 (이벤트만 호출 - 기획전은 evtExhibitions.js 에서 처리)
                if (!vcui.isEmpty(targetId) && targetId.indexOf("EV") > -1 && 'Y' != eventEndFlag) {
                    var ajaxUrl = "/evt/event/insertEventHistoryView.lgajax";
                    // BTOCSITE-109357 event api 개인추천 기획전 조회 블로킹 필요
                    lgkorUI.retrieveEventFlag().then(e => {
                        if(!e) lgkorUI.requestAjaxDataPost(ajaxUrl, {'targetId' :  targetId}, function(result) {});
                    });
                }
            },

            setting: function() {
                var slideList = $('.box-list').find('.ui_carousel_list').find('#contentsSlide.slide-track'); //BTOCSITE-56094
                var ajaxUrl = $('.recomm-exhibitions-inner').attr('data-list-url');
                var targetId = $('.recomm-exhibitions-inner').attr('data-target-id');

                // BTOCSITE-109357 event api 개인추천 기획전 조회 블로킹 필요
                lgkorUI.retrieveEventFlag().then(e => {
                    if(e) return;

                    // 기존 API 호출
                    lgkorUI.requestAjaxDataPost(ajaxUrl, {'targetId' :  targetId}, function(result) {

                        var list = result.data[0];
                        var areaTitle = list.areaTitle;
                        var scenarioNumber = list.scenarioNumber;

                        // 이벤트/기획전이 4개 이상인 경우만 노출
                        if (list && list.eventList && list.eventList.length > 3) {

                            // 컨텐츠 리스트 추가
                            slideList.append(vcui.template(EVT_ItemTemplate, list));

                            // LazyMediaLoader 감시 목록에 추가 (common.js)
                            if (typeof PV !== 'undefined' && PV.LazyMediaLoader && typeof PV.LazyMediaLoader.refresh === 'function') {
                                PV.LazyMediaLoader.refresh(slideList[0]);
                            } else {
                                slideList.find('img[data-lazy-src]').each(function() {
                                    var $img = $(this);
                                    if (!$img.attr('src')) {
                                        $img.attr('src', $img.attr('data-lazy-src'));
                                        $img.removeClass('c-lazy-media__element');
                                        $img.closest('.c-lazy-media').removeClass('c-lazy-media');
                                    }
                                });
                            }

                            $('#recommendAreaTitle').html(areaTitle);
                            $(".recomm-exhibitions-inner").show();
                            isRecommendVisible = true;

                            // 컨텐츠 링크 URL 이 이벤트/기획전 내부 URL이 아닌 경우 히스토리 ajax 별도 호출 (예>B2B 이벤트)
                            $("#contentsSlide").find("li").each(function(){
                                var $targetAnchor = $(this).find("a");
                                var targetUrl = $targetAnchor.attr("href");
                                var linkTargetId = $(this).find("a").attr("data-target-id");
                                // 내부 페이지가 아닌 경우 별도 이력 저장
                                if (!vcui.isEmpty(targetUrl) && targetUrl.indexOf("/benefits/exhibitions/detail") == -1 && targetUrl.indexOf("/benefits/event/detail") == -1 ) {
                                    $targetAnchor.attr("href", "javascript:void(0)");
                                    $targetAnchor.on("click", function () {
                                        insertEventViewHistory(linkTargetId, targetUrl);
                                    });
                                }
                            });

                            // 슬라이드 초기화
                            initCarousel();

                            // 리사이즈 이벤트 트리거
                            $(window).on('resize', function(e){
                                initCarousel();
                            }).trigger('resize');

                            // GA Data setting
                            var eventLabel = scenarioNumber;    // 시나리오 번호
                            for (var i = 0 ; i < list.eventList.length ; i++) {
                                eventLabel += "/" + list.eventList[i].eventId;
                            }
                            gaData = {'event' : 'customEvent',
                                'ga4event' : 'banner_impression',
                                'customEventCategory': '배너노출',
                                'customEventAction': targetId.startsWith('PE') ? '배너 노출 - 기획전 영역' : '배너 노출 - 이벤트 영역',
                                'customEventLabel': eventLabel
                            };
                        }
                    });

                    /* 신규 API 호출 (OMS 프로젝트 오픈 후 API 변경작업 이후에 신규 API 호출 필요)
                    lgkorUI.requestKongAjax("eventsvc", "/ajax/v1/event/retrieveRecommendEventList", {
                        method: "POST",
                        data: {
                            targetId: targetId
                        },
                        success: function(result) {
                            var list = result.data;
                            var areaTitle = list.areaTitle;
                            var scenarioNumber = list.scenarioNumber;

                            // 이벤트/기획전이 4개 이상인 경우만 노출
                            if (list && list.eventList && list.eventList.length > 3) {

                                // 컨텐츠 리스트 추가
                                slideList.append(vcui.template(EVT_ItemTemplate, list));
                                $('#recommendAreaTitle').html(areaTitle);
                                $(".recomm-exhibitions-inner").show();
                                isRecommendVisible = true;

                                // 컨텐츠 링크 URL 이 이벤트/기획전 내부 URL이 아닌 경우 히스토리 ajax 별도 호출 (예>B2B 이벤트)
                                $("#contentsSlide").find("li").each(function(){
                                    var $targetAnchor = $(this).find("a");
                                    var targetUrl = $targetAnchor.attr("href");
                                    var linkTargetId = $(this).find("a").attr("data-target-id");
                                    // 내부 페이지가 아닌 경우 별도 이력 저장
                                    if (!vcui.isEmpty(targetUrl) && targetUrl.indexOf("/benefits/exhibitions/detail") == -1 && targetUrl.indexOf("/benefits/event/detail") == -1 ) {
                                        $targetAnchor.attr("href", "javascript:void(0)");
                                        $targetAnchor.on("click", function () {
                                            insertEventViewHistory(linkTargetId, targetUrl);
                                        });
                                    }
                                });

                                // 슬라이드 초기화
                                initCarousel();

                                // 리사이즈 이벤트 트리거
                                $(window).on('resize', function(e){
                                    initCarousel();
                                }).trigger('resize');

                                // GA Data setting
                                var eventLabel = scenarioNumber;    // 시나리오 번호
                                for (var i = 0 ; i < list.eventList.length ; i++) {
                                    eventLabel += "/" + list.eventList[i].eventId;
                                }
                                gaData = {'event' : 'customEvent',
                                    'ga4event' : 'banner_impression',
                                    'customEventCategory': '배너노출',
                                    'customEventAction': targetId.startsWith('PE') ? '배너 노출 - 기획전 영역' : '배너 노출 - 이벤트 영역',
                                    'customEventLabel': eventLabel
                                };
                            }
                        },
                        error: function(jqXHR) {
                            console.log(jqXHR)
                        }
                    });
                    */
                })
            },
            checkViewRecommendList : function() {
                if ( isRecommendVisible && evtDetail_SlideList.checkVisible()) {
                    // GA Data push
                    if (typeof dataLayer !== 'undefined' && dataLayer) {
                        dataLayer.push(gaData);
                    }
                    window.removeEventListener('scroll', evtDetail_SlideList.checkViewRecommendList);
                }
            },
    
            checkVisible : function() {
                var viewportHeight = $(window).height(); // Viewport Height
                var scrolltop = $(window).scrollTop(); // Scroll Top
                var y = $(".ev-detail-bottom").eq(0).find(".recomm-exhibitions-inner").offset().top + $(".ev-detail-bottom").eq(0).find(".recomm-exhibitions-inner").height();
    
                // 화면에 안보여도 요소가 위에만 있으면 (페이지를 로드할때 스크롤이 밑으로 내려가 요소를 지나쳐 버릴경우)
                return ((y < (viewportHeight + scrolltop)));
            }
        }

        evtDetail_SlideList.init();

        //BTOCSITE-48333
        var isSetCarousel = false;
        function initCarousel() {
            var $slide = $('.recomm-exhibitions-inner .slide-wrap');
            if (window.innerWidth < 768) {
                if(isSetCarousel == true){
                    $slide.vcCarousel('destroy');
                }
                isSetCarousel = false;
            } else{
                if(isSetCarousel == false){
                    $slide.vcCarousel({
                        infinite: false,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        speed: 150
                    });
                }
                isSetCarousel = true;
            }
        }

        function insertEventViewHistory(targetId, url) {
            var ajaxUrl = "/evt/event/insertEventHistoryView.lgajax";
            lgkorUI.requestAjaxDataPost(ajaxUrl, {'targetId' :  targetId}, function(result) {
                location.href = url;
            });
        }

        function addMyRecentEventCookie() {
            var targetId = $('.recomm-exhibitions-inner').attr('data-target-id');
            var cookieName = 'myRecentEvent';
            if(targetId && targetId.length > 0) {
                // 쿠키 값 조회
                var items = lgkorUI.getCookie(cookieName, true);
                var itemArray = [];
                if(items) {
                    itemArray = items.split(',');
                    //겹치는 값 제거
                    var findIndex = -1;
                    for(var n=0 ; n < itemArray.length ; n++) {
                        var value = itemArray[n];
                        if(value == targetId) {
                            findIndex = n;
                            break;
                        }
                    };
                    if(findIndex != -1) {
                        itemArray.splice(findIndex, 1);
                    }
                }
                itemArray.unshift(targetId);
                // 쿠키 저장
                lgkorUI.setCookie(cookieName, itemArray.join(','), false, null);
            }
        }

        // GA 수집을 위한 스크롤 이벤트 등록
        window.addEventListener('scroll', evtDetail_SlideList.checkViewRecommendList);
        
        ////BTOCSITE-48333

        //BTOCSITE-78792
        var $eventTabWrapTab = $('.event-tab-wrap .ui_stickyTab')
        if( $eventTabWrapTab.length >= 1 ){
            $('head').append('<style>.pause_sticky{position:relative !important;}</style>');
            $eventTabWrapTab.on('stickyTabchange',function(){
                if( window.innerWidth < 768 ){return}
                $eventTabWrapTab.parent().addClass('pause_sticky')
            })
            $eventTabWrapTab.parent().on('completeScrollTop',function(){
                if( window.innerWidth < 768 ){return}
                setTimeout(function(){
                     $(window).trigger('scroll');
                     $eventTabWrapTab.parent().removeClass('pause_sticky')
                },200) 
            });
            $(window).on('scroll',function(){
                if( window.innerWidth < 768 && vcui.detect.isMobile == true ){return}
                if( $eventTabWrapTab.parent().offset().top > $(window).scrollTop() || $(window).scrollTop()==0 ){
                    $eventTabWrapTab.parent().removeAttr('style').removeClass('up').removeClass('down').removeClass('fixed')
                }
            }).on('resizeend',function(){
                if( window.innerWidth < 768){
                    $eventTabWrapTab.parent().removeClass('pause_sticky')
                }
            });
        }
        ////BTOCSITE-78792 

    });
})();